import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/theme';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function LandingPage() {
  const { isDark } = useTheme();
  const colors = getThemeColors(isDark);
  
  return (
    <>
      <style>{`
        html, body {
          overflow-x: hidden !important;
        }
        @media (max-width: 900px) {
          .lp-main-content {
            align-items: center !important;
            text-align: center !important;
            padding: 0 4vw !important;
          }
          .lp-headline {
            font-size: 2.1rem !important;
            text-align: center !important;
          }
          .lp-badges {
            justify-content: center !important;
          }
          .lp-main-content .lp-btn-row {
            justify-content: center !important;
            width: 100% !important;
          }
          .lp-main-content a {
            min-width: 180px !important;
            max-width: 100% !important;
          }
          .lp-navbar-btn-row {
            flex-wrap: wrap !important;
            justify-content: flex-end !important;
            width: 100% !important;
            margin-left: 0 !important;
            gap: 10px !important;
          }
          .lp-navbar-btn-row a {
            min-width: 120px !important;
            max-width: none !important;
            text-align: center !important;
            padding-left: 12px !important;
            padding-right: 12px !important;
            white-space: normal !important;
            overflow: visible !important;
            text-overflow: unset !important;
          }
        }
        @media (max-width: 700px) {
          .lp-navbar-btn-row {
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            width: 100% !important;
            gap: 8px !important;
            margin-right: 0 !important;
            padding-top: 8px !important;
            margin-left: 0 !important;
          }
        }
        @media (max-width: 600px) {
          .lp-main-content {
            padding: 0 2vw !important;
          }
          .lp-headline {
            font-size: 1.4rem !important;
          }
        }
        .demo-steps-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }
        @media (max-width: 1200px) {
          .demo-steps-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 25px;
          }
        }
        @media (max-width: 768px) {
          .demo-steps-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
        }
      `}</style>
      <div style={{
        minHeight: '100vh',
        background: isDark ? `linear-gradient(90deg, ${colors.backgroundLight} 0%, ${colors.background} 100%)` : 'linear-gradient(90deg, #f1f5fe 0%, #fff 100%)',
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        transition: 'background 0.3s ease',
      }}>
        {/* Navbar */}
        <nav style={{
          width: '100%',
          minWidth: 0,
          background: colors.card,
          boxShadow: `0 2px 12px ${colors.shadow}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: '0 5vw',
          height: 72,
          position: 'relative',
          zIndex: 2,
          transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
        }}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <i className="fas fa-exchange-alt" style={{fontSize: 32, color: colors.primary, marginRight: 10}}></i>
            <span style={{fontWeight: 800, fontSize: 24, color: colors.primary, letterSpacing: 1}}>Konverter</span>
          </div>
          <div className="lp-navbar-btn-row" style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'nowrap',
            width: 'auto',
            justifyContent: 'flex-start',
            marginLeft: 32
          }}>
            <a href="/login" style={{color: colors.text, fontWeight: 600, fontSize: 16, marginRight: 0, textDecoration: 'none', minWidth: 120, textAlign: 'center', transition: 'color 0.2s'}}>Prijavi se</a>

          </div>
        </nav>
        {/* Main Content */}
        <main style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 0',
        }}>
          <div
            className="lp-main-content"
            style={{
              flex: 1,
              minWidth: 0,
              maxWidth: 600,
              width: '100%',
              textAlign: 'left',
              padding: '0 5vw',
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              transition: 'all 0.2s',
            }}
          >
            <div style={{color: colors.primary, fontWeight: 600, fontSize: 16, marginBottom: 12, transition: 'color 0.3s ease'}}>
              <i className="fas fa-bolt" style={{marginRight: 6, color: colors.primary}}></i> Novi pristup konverziji
            </div>
            <h1 className="lp-headline" style={{fontSize: 44, fontWeight: 900, lineHeight: 1.1, marginBottom: 12, maxWidth: '100%', transition: 'font-size 0.2s'}}>
              <span style={{color: colors.primary, transition: 'color 0.3s ease'}}>CSV/Excel Konverter</span>
            </h1>
            <p style={{fontSize: 20, color: colors.text, marginBottom: 32, maxWidth: 480, transition: 'color 0.3s ease'}}>
              Pretvorite i prilagodite vaše CSV ili Excel fajlove za knjigovodstvo, ERP ili eFakturu. Brzo, sigurno i na srpskom jeziku.
            </p>
            {/* Supported Softwares Segment */}
            <div style={{background: colors.backgroundLight, borderRadius: 12, border: `1px solid ${colors.border}`, padding: 20, marginBottom: 32, width: '100%', maxWidth: 480, transition: 'background-color 0.3s ease, border-color 0.3s ease'}}>
              <h3 style={{color: colors.primary, fontWeight: 800, fontSize: 18, marginBottom: 10, letterSpacing: 0.5, transition: 'color 0.3s ease'}}>Podržani softveri</h3>
              <div style={{display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                  <img src="https://www.tauryss.rs/images/logo/LogoTaur.PNG" alt="TAUR" style={{height: 32, width: 32, objectFit: 'contain', borderRadius: 6, border: `1px solid ${colors.border}`, background: colors.card, transition: 'border-color 0.3s ease, background-color 0.3s ease'}} onError={e => {e.target.onerror=null; e.target.src='https://via.placeholder.com/32x32?text=T';}} />
                  <span style={{fontWeight: 600, color: colors.text, transition: 'color 0.3s ease'}}>TAURYSS</span>
                </div>
              </div>
            </div>
            <div style={{
              display: 'flex',
              gap: 16,
              marginBottom: 28,
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              width: '100%',
              rowGap: 12,
            }}>
              <a href="/signup" style={{background: colors.primary, color: 'white', fontWeight: 700, fontSize: 18, borderRadius: 8, padding: '16px 36px', textDecoration: 'none', boxShadow: `0 2px 8px ${colors.shadow}`, width: 'auto', transition: 'background-color 0.2s, box-shadow 0.2s'}} onMouseEnter={(e) => e.target.style.background = colors.primaryHover} onMouseLeave={(e) => e.target.style.background = colors.primary}>Počni</a>
            </div>
            <div className="lp-badges" style={{display: 'flex', gap: 18, marginTop: 8, flexWrap: 'wrap', justifyContent: 'flex-start'}}>
              <span style={{fontSize: 15, color: colors.success, fontWeight: 600, display: 'flex', alignItems: 'center', transition: 'color 0.3s ease'}}><i className="fas fa-check-circle" style={{marginRight: 6}}></i>5 dana besplatno</span>
              <span style={{fontSize: 15, color: colors.text, fontWeight: 600, display: 'flex', alignItems: 'center', transition: 'color 0.3s ease'}}><i className="fas fa-language" style={{marginRight: 6}}></i>Na srpskom jeziku</span>
            </div>
          </div>
        </main>

        {/* Demo/Preview Section */}
        <section style={{
          background: '#fff',
          padding: '60px 0',
          borderTop: '1px solid #e5e7eb',
        }}>
          <div style={{
            maxWidth: 1200,
            margin: '0 auto',
            padding: '0 5vw',
          }}>
            <div style={{textAlign: 'center', marginBottom: 50}}>
              <h2 style={{fontSize: 36, fontWeight: 800, color: '#1e293b', marginBottom: 16}}>
                Kako funkcioniše konverter?
              </h2>
              <p style={{fontSize: 18, color: '#64748b', maxWidth: 600, margin: '0 auto'}}>
                Pogledajte kako jednostavno možete pretvoriti vaše fajlove u format kompatibilan sa TAURYSS sistemom
              </p>
            </div>

            {/* Demo Steps */}
            <div className="demo-steps-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 20,
              marginBottom: 50
            }}>
              {/* Step 1 */}
              <div style={{
                background: '#f8fafc',
                borderRadius: 12,
                padding: 20,
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer'
              }} onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-5px)';
                e.target.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
              }} onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                <div style={{
                  width: 50,
                  height: 50,
                  background: '#2563eb',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                  color: 'white',
                  fontSize: 20,
                  fontWeight: 700
                }}>
                  1
                </div>
                <h3 style={{fontSize: 18, fontWeight: 700, color: '#1e293b', marginBottom: 10}}>
                  Uploadujte fajl
                </h3>
                <p style={{color: '#64748b', lineHeight: 1.6}}>
                  Otpremite vaš CSV ili Excel fajl sa poslovnim podacima. Podržavamo sve uobičajene formate i automatski parsiramo podatke.
                </p>
                <div style={{
                  marginTop: 20,
                  padding: 15,
                  background: '#fff',
                  borderRadius: 8,
                  border: '2px dashed #cbd5e1',
                  color: '#64748b',
                  fontSize: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8
                }}>
                  <i className="fas fa-file-upload" style={{fontSize: 16}}></i>
                  <span>CSV • XLSX • XLS</span>
                </div>
              </div>

              {/* Step 2 */}
              <div style={{
                background: '#f8fafc',
                borderRadius: 12,
                padding: 20,
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer'
              }} onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-5px)';
                e.target.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
              }} onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                <div style={{
                  width: 50,
                  height: 50,
                  background: '#2563eb',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                  color: 'white',
                  fontSize: 20,
                  fontWeight: 700
                }}>
                  2
                </div>
                <h3 style={{fontSize: 18, fontWeight: 700, color: '#1e293b', marginBottom: 10}}>
                  Konvertujte kurs
                </h3>
                <p style={{color: '#64748b', lineHeight: 1.6}}>
                  Automatski konvertujte valute u dinare po aktuelnom kursu. Podržane su sve glavne valute (EUR, USD, CHF, GBP).
                </p>
                <div style={{
                  marginTop: 20,
                  padding: 15,
                  background: '#fff',
                  borderRadius: 8,
                  border: '1px solid #e5e7eb',
                  fontSize: 12,
                  textAlign: 'left'
                }}>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 8}}>
                    <span style={{color: '#64748b'}}>Originalna cena:</span>
                    <span style={{color: '#2563eb', fontWeight: 600}}>Konvertovano</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 4}}>
                    <span>100.00 EUR</span>
                    <span style={{color: '#22c55e'}}>→ 11,732.50 RSD</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 4}}>
                    <span>50.00 USD</span>
                    <span style={{color: '#22c55e'}}>→ 5,395.00 RSD</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <span style={{fontSize: 10, color: '#94a3b8'}}>Kurs od: {new Date().toLocaleDateString('sr-RS')}</span>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div style={{
                background: '#f8fafc',
                borderRadius: 12,
                padding: 20,
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer'
              }} onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-5px)';
                e.target.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
              }} onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                <div style={{
                  width: 50,
                  height: 50,
                  background: '#2563eb',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                  color: 'white',
                  fontSize: 20,
                  fontWeight: 700
                }}>
                  3
                </div>
                <h3 style={{fontSize: 18, fontWeight: 700, color: '#1e293b', marginBottom: 10}}>
                  Prevedite kolone
                </h3>
                <p style={{color: '#64748b', lineHeight: 1.6}}>
                  Automatski prevedite tekst sa stranog jezika na domaci jezik.
                </p>
                <div style={{
                  marginTop: 20,
                  padding: 15,
                  background: '#fff',
                  borderRadius: 8,
                  border: '1px solid #e5e7eb',
                  fontSize: 12,
                  textAlign: 'left'
                }}>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 8}}>
                    <span style={{color: '#64748b'}}>Strani jezik:</span>
                    <span style={{color: '#2563eb', fontWeight: 600}}>Domaći jezik</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 4}}>
                    <span>Product</span>
                    <span style={{color: '#22c55e'}}>→ Proizvod</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 4}}>
                    <span>Quantity</span>
                    <span style={{color: '#22c55e'}}>→ Količina</span>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <span>Description</span>
                    <span style={{color: '#22c55e'}}>→ Opis</span>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div style={{
                background: '#f8fafc',
                borderRadius: 12,
                padding: 20,
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer'
              }} onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-5px)';
                e.target.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
              }} onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                <div style={{
                  width: 50,
                  height: 50,
                  background: '#2563eb',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                  color: 'white',
                  fontSize: 20,
                  fontWeight: 700
                }}>
                  4
                </div>
                <h3 style={{fontSize: 18, fontWeight: 700, color: '#1e293b', marginBottom: 10}}>
                  Izvezite!
                </h3>
                <p style={{color: '#64748b', lineHeight: 1.6}}>
                  Mapirajte kolone sa TAURYSS poljima i izvezite finalni fajl spreman za uvoz u TAURYSS sistem.
                </p>
                <div style={{
                  marginTop: 20,
                  padding: 15,
                  background: '#fff',
                  borderRadius: 8,
                  border: '1px solid #e5e7eb',
                  color: '#22c55e',
                  fontSize: 14,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8
                }}>
                  <i className="fas fa-download"></i>
                  <span>TAURYSS_izvoz.txt</span>
                  <i className="fas fa-check-circle" style={{color: '#22c55e'}}></i>
                </div>
              </div>
            </div>

            {/* Interactive Demo */}
            <div style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: 20,
              padding: 40,
              textAlign: 'center',
              color: 'white',
              marginBottom: 40
            }}>
              <h3 style={{fontSize: 28, fontWeight: 700, marginBottom: 16}}>
                Isprobajte demo verziju
              </h3>
              <p style={{fontSize: 18, marginBottom: 30, opacity: 0.9}}>
                Učitajte test fajl i vidite kako funkcioniše konverter u praksi. Da biste koristili konverter, potrebno je da registrujete svoju firmu.
              </p>
              <div style={{
                display: 'flex',
                gap: 16,
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}>

                <a href="/signup" style={{
                  background: 'white',
                  color: '#667eea',
                  padding: '12px 24px',
                  borderRadius: 8,
                  fontSize: 16,
                  fontWeight: 600,
                  textDecoration: 'none',
                  transition: 'all 0.2s'
                }} onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                }} onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}>
                  Registruj se besplatno
                </a>
              </div>
            </div>

            {/* Features Grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: 20
            }}>
              <div style={{textAlign: 'center', padding: 20}}>
                <i className="fas fa-shield-alt" style={{fontSize: 32, color: '#2563eb', marginBottom: 12}}></i>
                <h4 style={{fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 8}}>Sigurnost</h4>
                <p style={{color: '#64748b', fontSize: 14}}>Vaši podaci su zaštićeni enkripcijom i automatski se brišu</p>
              </div>
              <div style={{textAlign: 'center', padding: 20}}>
                <i className="fas fa-bolt" style={{fontSize: 32, color: '#2563eb', marginBottom: 12}}></i>
                <h4 style={{fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 8}}>Brzina</h4>
                <p style={{color: '#64748b', fontSize: 14}}>Konverzija se vrši u sekundama, bez čekanja</p>
              </div>
              <div style={{textAlign: 'center', padding: 20}}>
                <i className="fas fa-check-circle" style={{fontSize: 32, color: '#2563eb', marginBottom: 12}}></i>
                <h4 style={{fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 8}}>Preciznost</h4>
                <p style={{color: '#64748b', fontSize: 14}}>100% kompatibilnost sa TAURYSS formatom</p>
              </div>
              <div style={{textAlign: 'center', padding: 20}}>
                <i className="fas fa-headset" style={{fontSize: 32, color: '#2563eb', marginBottom: 12}}></i>
                <h4 style={{fontSize: 18, fontWeight: 600, color: '#1e293b', marginBottom: 8}}>Podrška</h4>
                <p style={{color: '#64748b', fontSize: 14}}>24/7 podrška na srpskom jeziku</p>
              </div>
            </div>
          </div>
        </section>
        <footer style={{
          width: '100%',
          background: '#f8fafc',
          borderTop: '1px solid #e5e7eb',
          padding: '24px 0 16px 0',
          marginTop: 48,
          textAlign: 'center',
          color: '#64748b',
          fontSize: 15,
        }}>
          <div style={{marginBottom: 8}}>
            &copy; {new Date().getFullYear()} Konverter. Sva prava zadržana.
          </div>
          <div style={{fontSize: 14, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '8px', alignItems: 'center'}}>
            <a href="/privacy" style={{color: '#2563eb', textDecoration: 'none'}}>Politika privatnosti</a>
            <span>|</span>
            <a href="/terms" style={{color: '#2563eb', textDecoration: 'none'}}>Uslovi korišćenja</a>
            <span>|</span>
            <a href="/refund" style={{color: '#2563eb', textDecoration: 'none'}}>Politika povraćaja</a>
            <span>|</span>
            <a href="mailto:nemanja@lizzardsolutions.com" style={{color: '#2563eb', textDecoration: 'none'}}>nemanja@lizzardsolutions.com</a>
          </div>
        </footer>
      </div>
    </>
  );
} 